declare global {
  interface Window {
    __ENV__?: {
      VITE_API_BASE_URL?: string;
      VITE_APP_NAME?: string;
      VITE_APP_CODE?: string;
      [key: string]: string | undefined;
    };
  }
}

/**
 * Centralized, type-safe access to environment variables.
 * Prioritizes runtime configuration (window.__ENV__) over build-time (import.meta.env)
 * to allow dynamic environment variables when deploying on Kubernetes.
 */
export const env = {
  API_BASE_URL:
    (typeof window !== 'undefined' && window.__ENV__?.VITE_API_BASE_URL !== undefined)
      ? window.__ENV__.VITE_API_BASE_URL
      : import.meta.env.VITE_API_BASE_URL || '',
  APP_NAME:
    (typeof window !== 'undefined' && window.__ENV__?.VITE_APP_NAME) ||
    import.meta.env.VITE_APP_NAME ||
    'CMS PNR',
  APP_CODE:
    (typeof window !== 'undefined' && window.__ENV__?.VITE_APP_CODE) ||
    import.meta.env.VITE_APP_CODE ||
    'pnr',
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
} as const;

